import { z } from "zod";
import { DTOUser } from "../users";
import { ForgeProjectMembership, ForgeProjectRole } from "@supernova-studio/model";

export const DTOForgeProjectMemberRole = ForgeProjectRole;

export const DTOForgeProjectMember = ForgeProjectMembership.extend({
  user: DTOUser,
  effectiveRole: DTOForgeProjectMemberRole,
});

export const DTOCreateForgeProjectMember = DTOForgeProjectMember.pick({
  userId: true,
  role: true,
});

export const DTOUpdateForgeProjectMember = DTOCreateForgeProjectMember.omit({ userId: true });

export const DTORemoveForgeProjectMember = DTOForgeProjectMember.pick({
  userId: true,
});

export const DTOForgeProjectMembersListResponse = z.object({
  members: z.array(DTOForgeProjectMember),
});

export const DTOForgeProjectMemberGetResponse = z.object({
  member: DTOForgeProjectMember.nullable(),
});

export const DTOForgeProjectMemberCreateResponse = z.object({
  member: DTOForgeProjectMember,
});

export const DTOForgeProjectMemberUpdateResponse = z.object({
  member: DTOForgeProjectMember.nullable(),
});

export const DTOForgeProjectMemberRemoveResponse = z.object({
  ok: z.literal(true),
});

export type DTOForgeProjectMemberRole = z.infer<typeof DTOForgeProjectMemberRole>;
export type DTOForgeProjectMember = z.infer<typeof DTOForgeProjectMember>;
export type DTOCreateForgeProjectMember = z.infer<typeof DTOCreateForgeProjectMember>;
export type DTOUpdateForgeProjectMember = z.infer<typeof DTOUpdateForgeProjectMember>;
export type DTORemoveForgeProjectMember = z.infer<typeof DTORemoveForgeProjectMember>;
export type DTOForgeProjectMembersListResponse = z.infer<typeof DTOForgeProjectMembersListResponse>;
export type DTOForgeProjectMemberGetResponse = z.infer<typeof DTOForgeProjectMemberGetResponse>;
export type DTOForgeProjectMemberCreateResponse = z.infer<typeof DTOForgeProjectMemberCreateResponse>;
export type DTOForgeProjectMemberUpdateResponse = z.infer<typeof DTOForgeProjectMemberUpdateResponse>;
export type DTOForgeProjectMemberRemoveResponse = z.infer<typeof DTOForgeProjectMemberRemoveResponse>;
